import DataIcon from "assets/images/calender.svg";
import CompaniesIcon from "assets/images/companies.svg";
import DashboardIcon from "assets/images/dashboard.svg";
import ReportsIcon from "assets/images/file.svg";
import NewsIcon from "assets/images/side_news_logo.svg";
import InsightsIcon from "assets/images/insights.svg";
import ModelsIcon from "assets/images/models.svg";
import SettingsIcon from "assets/images/setting.svg";
import RingIcon from "assets/images/ring.svg";
import NotificationsIcon from "assets/images/notification.svg";
import HelpIcon from "assets/images/help.svg";
import LogoutIcon from "assets/images/sign-out-alt.svg";

export const sidebarLinks = [
  {
    label: "Dashboard",
    labelKey: "nav.dashboard",
    icon: DashboardIcon,
    route: "/dashboard",
    module: "charts",
    children: [],
  },
  {
    label: "News",
    labelKey: "nav.news",
    icon: NewsIcon,
    route: "/news",
    module: "news",
    children: [
      { route: "", component: "NewsList" },
      { route: "matching-news", component: "MatchingNews" },
      { route: "news-view", component: "NewsView" },
    ],
  },
  {
    label: "Charts",
    labelKey: "nav.charts",
    icon: DataIcon,
    route: "/charts",
    module: "charts",
    children: [],
  },
  {
    label: "Reports",
    labelKey: "nav.reports",
    icon: ReportsIcon,
    route: "/reports",
    module: "reports",
    children: [],
  },
];

export const secondaryLinks = [
  {
    label: "Admin",
    labelKey: "nav.admin",
    icon: RingIcon,
    route: "/admin",
    module: "admin",
  },
  {
    label: "Notifications",
    labelKey: "nav.notifications",
    icon: NotificationsIcon,
    route: "/notifications",
    module: "notifications",
    hidden: true,
    disabled: true,
    badge: 2,
  },
  {
    label: "Help",
    labelKey: "nav.help",
    icon: HelpIcon,
    route: "/help",
    module: "help",
    hidden: true,
    disabled: true,
  },
  {
    label: "Settings",
    labelKey: "nav.settings",
    icon: SettingsIcon,
    route: "/settings",
    module: "settings",
    children: [],
  },
  {
    label: "Logout",
    labelKey: "nav.logout",
    icon: LogoutIcon,
    route: "/logout",
    module: "logout",
  },
];
